import React from 'react';
import './main-link.scss';
function MainLink(props) {
    return (
        <a {...props} className={"coach-link "+(props.className || '')} aria-label={props.children} role="link" tabIndex="0">{props.children}</a>
    );
}
  
export default MainLink;